// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAQkksx7thbwBuPeDlUfFy-W3OqlC0jMlw",
  authDomain: "businessdatabase03-428a1.firebaseapp.com",
  projectId: "businessdatabase03-428a1",
  storageBucket: "businessdatabase03-428a1.firebasestorage.app",
  messagingSenderId: "1069749974584",
  appId: "1:1069749974584:web:277a35d016262374f298cd"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;
